module.exports = __webpack_public_path__ + "img/advntm-yellow.a29dcd3b.svg";